export default {
  contractAttachments: [],
  contractAttachment: undefined,
};
